import React, {useEffect} from 'react';
import maintenance from '../../assets/mantenimiento.jpg';

const Maintenance = () => {

    useEffect(() => {
        localStorage.clear();
    }, []);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100vw',
            overflow: 'hidden',
        }}>
            <img
                alt="gifLogo"
                src={maintenance}
                style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'cover',
                }}
            />
        </div>

    );
}

export default Maintenance;
